import React from "react";
import {Link} from 'react-router-dom'
import {TicTacEncabezado3,TicTacParafh1,TicTacView1,TictacDivBlock1,TicTacBody,TicTacListas
} from "./FormasTicTac";
import {TictacOther2} from "./componentTicTac/TicTacOther";
import TicTacText from "./componentTicTac/TicTacText";
import TicTacSee from "./componentTicTac/TicTacSee";

import "./reference.css";

export function Tictac( props ){
  const see = props.props.img.length;
  const text = props.props.parrafo.length;
  function chek(){
    if (window.confirm("¿ IR A PÁGINA  ?")) {
      window.open("https://www.dailymotion.com/video/x8jpy2b");
    } else {
      window.alert(
        "¡ Seleccionaste -> <Cancelar> !!! Estás en Coronados"
      );
    }
  }
  //    Funcion                 FORMATEAR PAR CORREGIR
  function outText (titulo,lasttitle,epigrafe,parrafo,lista,table,cuerpo,codigo,codigo2,tic,tac,view) {
    if ( view[0] === "NaN" ) {
      return (
        <>
          <TicTacEncabezado3 title={titulo} subtitle={lasttitle} epigraph={epigrafe}/>
          <TicTacListas list={lista} />
          <TicTacParafh1 parafh={parrafo} />
          <TicTacBody tictac={tic} under={tac} />
          <hr />
        </>
      );
    } else if ( parrafo[0] === "NaN" ) {
      return (
        <>
          <TicTacEncabezado3 title={titulo} subtitle={lasttitle} epigraph={epigrafe}/>
          <TicTacListas list={lista} />
          <TicTacView1 capture={view} />
          <TicTacBody tictac={tic} under={tac} />
          <hr />
        </>
      );
    } else if ( titulo[0] === "Redes Neuronales - Inteligencia artificial" ) {
      return (
        <>
          <TictacOther2 titulo={titulo} lasttitle={lasttitle} epigrafe={epigrafe} parrafo={parrafo} tabla={table} cuerpo={cuerpo} code={codigo} code2={codigo2} view={view}/>
          <br />
          <Link className="linkDin" to={""} target="_blank"
              onClick={(e) => { e.preventDefault(); chek();}}> 
              VIDEO<div><br /><br /></div> 
          </Link>
          {" "}
          <hr />
        </>
      )
    }   else {
      if ( see < text ) {
        return (
          <>
            {/*Más parrafos*/}
            <TicTacEncabezado3 title={titulo} subtitle={lasttitle} epigraph={epigrafe}/>
            <TicTacText lengthDimention={see} capture={view} parafh={parrafo} />
            <TicTacBody tictac={tic} under={tac} />
            <br />
            <hr />
          </>
        );
      } else if ( see > text ) {
        return (
          <>
            {/*Más vistas*/}
            <TicTacEncabezado3 title={titulo} subtitle={lasttitle} epigraph={epigrafe}/>
            <TicTacSee lengthDimention={text} capture={view} parafh={parrafo} />
            <br />
            <hr />
          </>
        );
      } else {
        return (
          <>
            <TicTacEncabezado3 title={titulo} subtitle={lasttitle} epigraph={epigrafe}/>
            <TictacDivBlock1 parafh={parrafo} capture={view} />
            <TicTacBody tictac={tic} under={tac} />
            <hr />
          </>
        );
      }
    }
  }
  //  FIN FUNCION
  return (
    <>
      {outText(props.props.title,props.props.lasttitle,props.props.epigraph,props.props.parrafo,
        props.props.list,props.props.table,props.props.cuerpo,props.props.code,props.props.code2,
        props.props.tic,props.props.tac,props.props.img)}
    </>
  );
}
